const { client } = require('../../MbaasClient')

export const funcGetOneBlastSms = async (resource, params) => {
  const { data } = await client.getTable('notifications').lookup(params.id)
  return {
    data: { ...data },
  }
}
